export class Anio{
	constructor(
		public id: number, 
		public nombre: string,
		public estatus: number
	){}
}